module.exports = __webpack_public_path__ + "static/media/Scarf_Yellow_01.c03a7cbb.png";